import React, { FC, PropsWithChildren } from 'react';
import { View } from '@tarojs/components';

interface ITabPaneProps {
  id?: string;
  activeKey?: string;
  tab: string;
}

const TabPane: FC<PropsWithChildren<ITabPaneProps>> = ({ children, id, activeKey }) => {
  return <View className={`ace-tab-pane ${id === activeKey ? 'ace-tab-pane__active' : 'ace-tab-pane__inactive'}`}>{children}</View>;
};

export default TabPane;
